<p-card class="item-card-border cursor-pointer" role="button" (click)="addOrEditCard()" (keydown.enter)="addOrEditCard()" (keydown.space)="addOrEditCard()" tabindex="0">
    <div class="flex flex-row justify-content-between align-items-center flex-wrap">
        <p class="pl-0 text-blue-700 flex align-items-center gap-2 m-0 font-medium">
            <i class="pi pi-plus"></i>
            {{ label || 'Credit card' }}
        </p>
        <div class="flex flex-row gap-1 justify-content-end sm:h-2rem align-items-center" [ngClass]="{'align-items-center': isMobileView}">
            <img src="/assets/logos/Visa.svg" alt="visa card" class="web-view" />
            <img src="/assets/logos/Mastercard.svg" alt="master card" class="web-view" />
            <img src="/assets/logos/Discover.svg" alt="discover card" class="web-view" />
            <img src="/assets/logos/Amex.svg" alt="amex card" class="web-view" />
            <i class="pi pi-credit-card mobile-view mr-2"></i>
        </div>
    </div>
</p-card>
